// extracted by mini-css-extract-plugin
export var description = "ShipCard-module--description--d5250";
export var facilities = "ShipCard-module--facilities--36509";
export var facilitiesContainer = "ShipCard-module--facilities-container--b6546";
export var footer = "ShipCard-module--footer--32b5b";
export var image = "ShipCard-module--image--4c3a3";
export var nameContainer = "ShipCard-module--name-container--73758";
export var shipCard = "ShipCard-module--ship-card--44d51";
export var shipType = "ShipCard-module--ship-type--2d195";
export var shipTypeExpedition = "ShipCard-module--ship-type-expedition--1ea44";
export var techDetail = "ShipCard-module--tech-detail--80a57";
export var techDetailLabel = "ShipCard-module--tech-detail-label--92edf";
export var techDetailValue = "ShipCard-module--tech-detail-value--f697d";
export var techDetails = "ShipCard-module--tech-details--8f814";
export var techDetailsContainer = "ShipCard-module--tech-details-container--e12c8";
export var title = "ShipCard-module--title--74c3b";
export var variantLeft = "ShipCard-module--variant-left--3879a";
export var variantRight = "ShipCard-module--variant-right--1b1d7";